import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Page not found | ManagedSite.net';
    const description = 'That page is not on ManagedSite.net.';
    const setMeta = (selector, value) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute('content', value);
    };
    setMeta('meta[name="description"]', description);
    setMeta('meta[name="robots"]', 'noindex,follow');
    return () => setMeta('meta[name="robots"]', 'index,follow');
  }, []);

  return (
    <section className="bg-[#FAF8F3] pt-24 pb-28 lg:pt-36 lg:pb-36">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="mb-6 text-xs font-bold uppercase tracking-[0.2em] text-[#3B7C6D]">
            404
          </div>
          <h1 className="text-5xl leading-tight sm:text-6xl lg:text-7xl">
            That page is not here.
          </h1>
          <p className="mt-8 max-w-2xl text-xl leading-relaxed text-[#17211E]/70">
            The address may be old, or it was never a page on this site.
          </p>
          <div className="mt-10 flex flex-col gap-4 sm:flex-row">
            <Link to="/" className="home-button">
              Go to the homepage
            </Link>
            <Link to="/digital-review" className="home-button-secondary">
              Request a Digital Review
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
